const types = {
  SCHOOLID: 'SCHOOLID',
}



export default {
  state:{
    schoolId: "",
  },
  getters:{
    schoolId: state=>{
      return state.schoolId;
    }
  },
  mutations:{
    [types.SCHOOLID](state, params) {
      state.schoolId = params;
    },
  }
}